import { createFileRoute } from '@tanstack/react-router'
import {
  ADMIN_USER_FILTER_KEYS,
  ADMIN_USER_SORT_IDS,
} from '@/features/users/components/users/admin-users-columns'
import { AdminUsersPage } from '@/features/users/pages/admin-users-page'
import { createTableSearchSchema } from '@/lib/data-table/search-schema'

const usersSearchSchema = createTableSearchSchema({
  defaultPageSize: 20,
  sortIds: ADMIN_USER_SORT_IDS,
  filterKeys: ADMIN_USER_FILTER_KEYS,
  multiFilterKeys: ['createdAt'],
})

export const Route = createFileRoute('/users')({
  staticData: { title: 'Users' },
  validateSearch: usersSearchSchema,
  component: AdminUsersPage,
})
